import BannerTravelRounded from './BannerTravelRounded';

export default BannerTravelRounded;
